import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=667c0613&scoped=true&"
import script from "./Tel.vue?vue&type=script&lang=js&"
export * from "./Tel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c0613",
  null
  
)

export default component.exports